<template>
  <UButton size="lg">
    <MDCSlot unwrap="p" />
  </UButton>
</template>